import { createBrowserHistory } from 'history'
import moment from 'moment'

export const templateUserId = process.env.NODE_ENV === 'development' ? 1 : 73748

// TODO: verificar se fernando ou alguém possui uma regex melhor
/* eslint-disable no-useless-escape */
export const emailRegex = /^([-!#-\'*+\/-9=?A-Z^-~]{1,64}(\.[-!#-\'*+\/-9=?A-Z^-~]{1,64})*|"([]!#-[^-~ \t]|(\\[\t -~]))+")@[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?)+$/

export const pageSize = {
  width: 354,
  height: 498
}

export const filterTypes = [
  { type: 'ALPHABETICAL', translation: 'filter-alphabetical' },
  { type: 'DATE', translation: 'filter-date' }
]

export const keyboard = {
  SHIFT: 16,
  ESC: 27
}

export const getLanguageUrl = code => {
  return `https://www.omb11.com/api/publish?d=2&p=we23we23&act=get-translation&language=${code}&id_category=82`
}

//
// CUSTOM HISTORY CREATE TO
// ENALBLE CALL HISTORY OUTSIDE REACT COMPONENTS
export const historyObject = createBrowserHistory( {
  basename: '/'
} )

export const getFormatedDate = (
  date,
  withTime = false,
  dateFormat = 'en_US'
) => {
  const code = {
    en_us: 'MM/DD/YYYY',
    pt_br: 'DD/MM/YYYY',
    it_it: 'DD/MM/YYYY',
    es_es: 'DD/MM/YYYY',
    fr_fr: 'DD/MM/YYYY',
    de_de: 'DD/MM/YYYY'
  }

  const dateType =  code[dateFormat ? dateFormat.toLowerCase() : dateFormat] || dateFormat
  const format = withTime ? `${dateType} HH:mm:ss` : `${dateType}`
  return moment.utc( date ).format( format )
}

// TEMPLATE USED ON
// MAGAZINE EXPORT
export const pdfHtmlTemplate = `<html>
  <head>
    <style>
      @page { size: 350mm 500mm; margin: 0cm }
      body {
        margin: 0;
        padding: 0;
      }
    </style>
    $$styles
  </head>
  <body>$$pages</body>
</html>
`



// WEBPACK FOOTER //
// ./src/constants/index.js